import { useCallback } from "react";
import { useOkta } from "./OktaProvider";

export function useApiToken(): () => Promise<string> {
  const { getAccessToken } = useOkta();
  return useCallback(() => getAccessToken(), [getAccessToken]);
}
